import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ion_button, {
      size: "large",
      shape: "round",
      style: {"font-weight":"bold","--box-shadow":"0px 5px 5px gray"},
      "router-link": "/menu"
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(" START YOUR ORDER ")
      ])),
      _: 1,
      __: [0]
    })
  ]))
}